module.exports = __webpack_public_path__ + "img/miniprogram_douyin.8f8f03af.png";